import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { EventPageType } from '@graphql/generated-base';
import { CUSTOM_PAGE_PATH } from '@apps/guest/routes/GuestSite/GuestSite.constants';

export const getSlugFromPathname = (pathname: string) => {
  const isCustomPagePath = pathname.split('/')[2] === CUSTOM_PAGE_PATH;
  const pagePath = isCustomPagePath ? pathname.split('/')[3] : pathname.split('/')[2];
  return { pagePath, isCustomPagePath };
};

type GetPageInfoOptions = Readonly<{
  isMigratedCustomPageEnabled?: (slug: string) => boolean;
}>;

export const getPageInfo = (pages: ReadonlyArray<EventPageFragment>, pathname: string, options?: GetPageInfoOptions) => {
  const { pagePath, isCustomPagePath } = getSlugFromPathname(pathname);
  const pageFound = pages.find(p => p.pageSlug === pagePath);

  // Check if this is a migrated custom page (e.g., story) when the page's event flag is enabled.
  // This ensures telemetry correctly identifies the page type for routes like /${eventHandle}/story.
  const isMigratedCustomPage = pageFound?.pageSlug && !!options?.isMigratedCustomPageEnabled?.(pageFound.pageSlug) && pageFound.type === EventPageType.custom;

  const isCustomPage = isCustomPagePath || isMigratedCustomPage;
  return { pageSlug: isCustomPage ? EventPageType.custom : pageFound?.pageSlug, pageFound };
};
